<template>
    <section class="story-wrap" ref="story-wrap">
        <transition name="story">
            <div class="story-cover" v-show="initShow" @mousemove="mouseMoveHandler">
                <div class="story-itme" :class="[`story-item--${item.name}`, stroySelectedIndex === index ? 'active' : (stroySelectedIndex !== -1 ? 'inactive' : '')]" v-for="(item, index) in storyList" :key="`story-item-${index}`">
                    <div class="story-item-inner">
                        <div class="story-image-container" :style="parallaxStyle">
                            <div class="story-tip" :class="{ 'story-tip--focus': storyImageFocusIndex === index }">
                                <img :src="item.title.img" class="story-tip-img" alt="">
                            </div>
                            <div class="story-image-wrapper" :style="parallaxStyle" :class="{ 'story-image-wrapper--focus': storyImageFocusIndex === index }">
                                <img :src="item.sotryImg" class="story-image" alt="">
                            </div>
                            <a href="javascript: void(0);" v-show="stroySelectedIndex === -1" class="story-image-mask" @mouseenter="maskMouseEnter(index)" @mouseleave="maskMouseLeave" @click="showDetail(index)"></a>
                        </div>
                        <div class="story-detail">
                            <i class="iconfont iconguanbi1 story-detail-close" @click="hideDetail"></i>
                            <div class="story-detail-title">
                                <img :src="item.detail.title" class="story-detail-title-img" alt="">
                            </div>
                            <div class="story-detail-text" v-html="item.detail.text"></div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </section>
</template>

<script>
import {mapState, mapGetters} from 'vuex'

export default {
    name: "Story",

    components: {

    },
    data: () => ({
        storyList: [
            {
                name: "origin",
                title: {
                    kr: "오리지늄",
                    en: "Originiums",
                    img: require("../../assets/images/home/story/item_origin_tip.png"),
                },
                sotryImg: require("../../assets/images/home/story/item_origin.png"),
                detail: {
                    title: require("../../assets/images/home/story/item_origin_detail_tip.png"),
                    text: `
                    <p>'재앙'이라 불리는 원인불명의 자연재해가 대지를 휩쓸고 지나간 곳엔 막대한 양의 광석이 남겨져 있었고, 인류는 이 수수께끼의 광석을 '오리지늄'이라 불렀다.</p>
                    <p>훗날 오리지늄이 발견된 지 오랜 시간이 지나고 기술이 진보하며, 인류는 이 '오리지늄'이 가진 에너지를 공업에 사용하여 현대 문명을 발전시켰다. 그러나 사람들은 알지 못했다. 오리지늄으로 인해 '감염자'가 생겨나기 시작했다는 것을......</p>
                    `
                }
            },
            {
                name: "infected",
                title: {
                    kr: "감염자",
                    en: "Infected",
                    img: require("../../assets/images/home/story/item_infected_tip.png")
                },
                sotryImg: require("../../assets/images/home/story/item_infected.png"),
                detail: {
                    title: require("../../assets/images/home/story/item_infected_detail_tip.png"),
                    text: `
                    <p>사망 시 광석병이 확산된다는 점과 위험한 잠재능력 때문에 각국에선 일찍이 감염자들을 격리하거나 추방하여 왔지만, 그들에게 어떻게 살아가야 할지에 대해 알려주는 이는 아무도 없었다.</p>
                    <p>그리고, 이제 이 감염자들은 모든 것을 뒤엎고자 '리유니온' 이라는 폭동의 물결에 가담하기 시작했다.</p>
                    `
                }
            },
            {
                name: "reunion",
                title: {
                    kr: "리유니온",
                    en: "Reunion",
                    img: require("../../assets/images/home/story/item_reunion_tip.png")
                },
                sotryImg: require("../../assets/images/home/story/item_reunion.png"),
                detail: {
                    title: require("../../assets/images/home/story/item_reunion_detail_tip.png"),
                    text: `
                    <p>종족 구분없이 감염자들로만 이뤄진 단체로, 극단적으로 폐쇄적인 성향을 띄고 있다.</p>
                    <p>"감염자들은 자신의 신분에 자부심을 가져야 하며, 자신의 힘을 각성시키고 사용하는데 앞장서야 한다" 는 구호 아래 세계의 질서를 재편성하고자 어느 도시를 괴멸시키며 세상에 그 모습을 드러냈으나, 제약회사 '로도스 아일랜드'의 갑작스런 개입과 함께 사태는 점차 오리무중으로 빠져들게 되는데......</p>
                    `
                }
            },
            {
                name: "rhodes",
                title: {
                    kr: "이동도시",
                    en: "Rhodes Island",
                    img: require("../../assets/images/home/story/item_rhodes_tip.png")
                },
                sotryImg: require("../../assets/images/home/story/item_rhodes.png"),
                detail: {
                    title: require("../../assets/images/home/story/item_rhodes_detail_tip.png"),
                    text: `
                    로도스 아일랜드 제약회사. 대외적으론 제약회사라는 타이틀에 걸맞게 각 국가, 단체 및 개인 감염자용 치료 방안 연구를 진행 중인 것으로 알려져있으나, 실제로는 비밀리에 감염자 문제를 전문적으로 처리하고 있다. 로도스 아일랜드는 감염자로 인해 발발한 각종 문제 처리를 위해 군사 수단을 포함한 다양한 방식의 솔루션을 제공하고 있으며, 모든 로도스 아일랜드 직원에게 양질의 의료 서비스 및 생활 환경을 제공하여, 감염자는 물론 감염자의 처우를 개선하는 데 뜻을 함께하는 유능한 인재들을 끌어모으고 있다.
                    `
                }
            },
            {
                name: "mortal",
                title: {
                    kr: "이동도시",
                    en: "Nomadic City",
                    img: require("../../assets/images/home/story/item_mortal_city_tip.png")
                },
                sotryImg: require("../../assets/images/home/story/item_mortal_city.png"),
                detail: {
                    title: require("../../assets/images/home/story/item_mortal_city_detail_tip.png"),
                    text: `
                    <p>이동 시설 위에 건설한 도시. 막강한 파괴력의 각종 자연재해를 몰고 오는 '재앙'이 빈번히 발생하는 까닭에, 테라 행성에 존재하는 거의 모든 국가는 정기적으로 거처를 옮기며 안위를 유지해왔다.</p>
                    <p>이에 따라 인류는 점차 각종 건물과 기반시설을 이동 시설에 짓기 시작했고, 그 규모는 문명과 기술의 발전과 더불어 점차 커져, 오늘날의 거대한 '이동도시'로까지 이어지게 되었다.</p>
                    `
                }
            },
            {
                name: "crafts",
                title: {
                    kr: "오리지늄 아츠",
                    en: "Originium Arts",
                    img: require("../../assets/images/home/story/item_art_crafts_tip.png")
                },
                sotryImg: require("../../assets/images/home/story/item_art_crafts.png"),
                detail: {
                    title: require("../../assets/images/home/story/item_art_crafts_detail_tip.png"),
                    text: `
                    <p>오리지늄이 발견된 후 인류는 오리지늄을 이용해 물질의 고유 성질을 바꿀 수 있는 기술을 발견했다.</p>
                    <p>통상적으로는 '오리지늄 아츠'라고 불렸으나, 또 다른 말로는 '마법' 이라고도 불렸다. 흔히 오리지늄 아츠는 오리지늄 자체에서 나오는 에너지에 기반을 둔다 알려졌지만, 실제로는 사용자의 아츠 사용 가능 여부, 아츠 시전의 형식, 시전 강도, 시전 효과 등, 선천적 재능과 후천적 학습에도 영향을 받는다.</p>
                    `
                }
            },
        ],
        storyImageFocusIndex: -1,     // 图片缩放标识
        stroySelectedIndex: -1,       // 图片选中标识
        initShow: false,              // 第一次进入该板块标识
        parallax_pos: {               // 视差偏移值
            x: 0,
            y: 0
        },
        mouse_pos: {                  // 鼠标屏幕移动坐标
            x: 0,
            y: 0
        }
    }),
    created() {
        
    },
    mounted() {
    },
    watch: {
        NAV_ACTIVE_INDEX(val) {
            if(val === 3) {
                this.initShow = true
                this.animateImage()     // 开启动画
            }
        }
    },
    computed: {
        ...mapGetters({
            NAV_ACTIVE_INDEX: 'Home/NAV_ACTIVE_INDEX'
        }),
        parallaxStyle() {       // 鼠标滑动时，视差样式
            return `transform: translate(${this.parallax_pos.x}%, ${this.parallax_pos.y}%);`
        }
    },
    methods: {
        maskMouseEnter(index) {
            this.storyImageFocusIndex = index
        },
        maskMouseLeave() {
            this.storyImageFocusIndex = -1
        },
        showDetail(index) {
            this.stroySelectedIndex = index
        },
        hideDetail() {
            this.stroySelectedIndex = -1
            this.animateImage()
        },
        getStep(delValue, minValue) {
            if(Math.abs(delValue) - minValue < 0) {
                return delValue
            }
            let stepValue = Math.abs(delValue / 20)
            stepValue = (stepValue - minValue) > 0 ? stepValue : minValue
            return delValue > 0 ? stepValue : (stepValue * -1)
        },
        mouseMoveHandler(event) {
            let boxW = this.$refs['story-wrap'].clientWidth
            let boxH = this.$refs['story-wrap'].clientHeight
            
            this.mouse_pos.x = (event.clientX / boxW - 0.5) * 5
            this.mouse_pos.y = (event.clientY / boxH - 0.5) * 5
        },
        animateImage() {
            this.parallax_pos.x = this.parallax_pos.x + this.getStep(this.mouse_pos.x - this.parallax_pos.x, 0.001)
            this.parallax_pos.y = this.parallax_pos.y + this.getStep(this.mouse_pos.y - this.parallax_pos.y, 0.001)

            if(this.NAV_ACTIVE_INDEX === 3 && this.stroySelectedIndex === -1) {       // 离开停止
                window.requestAnimationFrame(this.animateImage);
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.story-wrap {
    background: url("../../assets/images/home/story/bg.jpg") no-repeat;
    background-size: cover;

    .story-cover {
        position: relative;
        width: 100%;
        height: 100%;

        .story-itme {
            position: absolute;
            transition: all ease-in-out .3s;

            .story-item-inner {
                position: absolute;
                width: 80%;
                height: 80%;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                // background: rgb(153, 153, 153);

                .story-image-container {
                    position: absolute;
                    width: 50%;
                    height: 0;
                    padding-top: 50%;

                    &::before {
                        content: "";
                        display: block;
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: url("../../assets/images/home/story/item_shadow.png") no-repeat;
                        background-size: 100% 100%;
                        transition: all ease-in-out .3s;
                    }

                    .story-tip {
                        position: absolute;
                        left: 22.5%;
                        width: 0;
                        transition: all ease-in-out .3s;
                        overflow: hidden;
                        opacity: .5;

                        .story-tip-img {
                            display: block;
                            height: pxTorem(68px);
                        }

                        &.story-tip--focus {
                            width: 100%;
                            opacity: 1;
                        }
                    }

                    .story-image-wrapper {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        top: 0;
                        // background: lightskyblue;

                        .story-image {
                            transition: transform ease-in-out .3s;
                            width: 100%;
                            height: 100%;
                        }

                        &.story-image-wrapper--focus {
                            .story-image {
                                transform: scale(1.1);
                            }
                        }
                    }
                    .story-image-mask {
                        display: block;
                        position: absolute;
                        left: 25%;
                        right: 25%;
                        top: 0;
                        bottom: 0;
                        cursor: pointer;
                        background: transparent;
                        // background: #d8674583;
                    }
                }
                .story-detail {
                    opacity: 0;
                    position: relative;
                    top: 50%;
                    transform: translateY(-50%);
                    margin: 0 18% 0 46%;

                    .story-detail-close {
                        position: absolute;
                        color: #000;
                        transform-origin: left center;
                        right: pxTorem(-5px);
                        bottom: 100%;
                        font-size: pxTorem(32px);
                        cursor: pointer;
                    }

                    .story-detail-title {
                        transform-origin: center bottom;
                        transform: scaleY(0);

                        .story-detail-title-img {
                            display: block;
                            height: pxTorem(42px);
                        }
                    }
                    .story-detail-text {
                        transform-origin: center bottom;
                        transform: scaleY(0);
                        font-family: 'Noto Sans KR', sans-serif;
                        font-size: pxTorem(16px);
                        font-weight: 700;
                        color: #010101;
                        word-break: keep-all;
                        border-top: 1px solid #000;
                        padding-top: pxTorem(22px);
                        margin-top: pxTorem(28px);
                        line-height: 1.5;

                        & ::v-deep p:not(:last-child) {
                            margin-bottom: pxTorem(15px);
                        }
                    }
                }
            }
            
            &.story-item--origin {
                width: 80%;
                height: 80%;
                left: -5%;
                top: 5%;
                // background: lightgoldenrodyellow;
                z-index: 1;

                .story-image-container::before {
                    top: 0;
                    left: 0;
                } 
                .story-tip {
                    top: 77.5%;
                }
            }
            &.story-item--infected {
                left: 47%;
                top: 40%;
                width: 40%;
                height: 40%;
                z-index: 3;
                transition-delay: 25ms;
                // background: lightgray;

                .story-image-container::before {
                    top: 15%;
                    left: 5%;
                } 
                .story-tip {
                    top: 92.5%;
                }
            }
            &.story-item--reunion {
                left: 35%;
                top: 0;
                width: 40%;
                height: 40%;
                transition-delay: 50ms;
                // background: lightgreen;
                z-index: 4;

                .story-image-container::before {
                    top: 20%;
                    left: 0;
                } 
                .story-tip {
                    top: 97.5%;
                }
            }
            &.story-item--rhodes {
                left: 68%;
                top: 40%;
                width: 60%;
                height: 60%;
                z-index: 4;
                transition-delay: 75ms;
                // background: lightpink;

                .story-image-container::before {
                    top: 0;
                    left: 0;
                } 
                .story-tip {
                    top: 75.5%;
                    left: -14% !important;
                }
            }
            &.story-item--mortal {
                left: 60%;
                top: -5%;
                width: 50%;
                height: 50%;
                z-index: 5;
                transition-delay: .1s;
                // background: lightskyblue;

                .story-image-container {
                    transition: margin ease-in-out .3s;
                }

                .story-image-container::before {
                    top: 20%;
                    left: 0;
                } 
                .story-tip {
                    top: 97.5%;
                }
            }
            &.story-item--crafts {
                left: 25%;
                top: 46%;
                width: 50%;
                height: 50%;
                transition-delay: 125ms;
                // background: lightseagreen;      
                z-index: 2;

                .story-image-container::before {
                    top: 10%;
                    left: 0;
                } 
                .story-tip {
                    top: 95%;
                }
            }

            // active
            &.active {
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                opacity: 1;
                z-index: 99;

                &.story-item--mortal {
                    .story-image-container {
                        margin-top: -5%;
                        margin-left: -3%;
                    }
                }

                .story-detail {
                    transition: all ease-in-out .3s .3s;
                    opacity: 1;

                    .story-detail-title {
                        transform: none;
                        opacity: 1;
                        transition: all ease-in-out .3s .3s;
                    }
                    .story-detail-text {
                        transition: all ease-in-out .3s .3s;
                        transform: none;
                        opacity: 1;
                    }
                }
            }
            // inactive
            &.inactive {
                opacity: 0;
                transform: translateY(-100%);
            }
        }
    }

    .story-enter-active, .story-leave-active {
        transition: all ease-in-out .6s .5s;
    }
    .story-enter, .story-leave-to {
        opacity: 0;
        transform: translateY(-20%);
    }
}
</style>
